<template>
<div class="main-body">
  <b-alert
    dismissible
    :show="showDismissibleAlert"
    :variant="alertVariant"
    @dismissed="showDismissibleAlert=false">{{ alertMessage }}</b-alert>
    <form>
      <div class="card">
          <div class="card-body">
              <div class="row">
                  <div class="col-sm-5">
                      <h4 class="card-title mb-0">
                        Shipper Management <small class="text-muted">shippers</small>
                      </h4>
                  </div><!--col-->
              </div><!--row-->

              <div class="row mt-4">
                  <div class="col">
                      <div class="form-group row">
                        <label for="courier_id" class="col-sm-2 col-form-label">{{ $t('shipper.courier_name') }}</label>
                        <div class="col-sm-4">
                          <select class="form-control" v-model.trim="shipper.courier_id">
                            <option v-for="(courier, index) in couriers" :value="courier.id" :key="index">{{ courier.name }}</option>
                          </select>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="shipper_account" class="col-sm-2 col-form-label form__label">{{ $t('shipper.shipper_account') }}</label>
                        <div class="col-sm-3" v-bind:class="{'form-group--error': $v.shipper.shipper_account.$error }">
                          <input v-model.trim="shipper.shipper_account" @input="$v.shipper.shipper_account.$touch()" type="text" name="shipper_account" class="form-control form__label">
                        </div>
                        <label for="billing_account" class="col-sm-2 col-form-label">{{ $t('shipper.billing_account') }}</label>
                        <div class="col-sm-3" v-bind:class="{'form-group--error': $v.shipper.billing_account.$error }">
                          <input v-model.trim="shipper.billing_account" @input="$v.shipper.billing_account.$touch()" type="text" name="billing_account" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="duty_account" class="col-sm-2 col-form-label">{{ $t('shipper.duty_account') }}</label>
                        <div class="col-sm-3" v-bind:class="{'form-group--error': $v.shipper.duty_account.$error }">
                          <input v-model.trim="shipper.duty_account" @input="$v.shipper.duty_account.$touch()" type="text" name="duty_account" class="form-control" />
                        </div>
                        <label for="shipper_id" class="col-sm-2 col-form-label">{{ $t('shipper.shipper_id') }}</label>
                        <div class="col-sm-3" v-bind:class="{'form-group--error': $v.shipper.shipper_id.$error }">
                          <input v-model.trim="shipper.shipper_id" @input="$v.shipper.shipper_id.$touch()" type="text" name="shipper_id" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="shipper_name" class="col-sm-2 col-form-label">{{ $t('shipper.shipper_name') }}</label>
                        <div class="col-sm-3" v-bind:class="{'form-group--error': $v.shipper.shipper_name.$error }">
                          <input v-model.trim="shipper.shipper_name" @input="$v.shipper.shipper_name.$touch()" type="text" name="shipper_name" class="form-control" />
                        </div>
                        <label for="registered_account" class="col-sm-2 col-form-label">{{ $t('shipper.registered_account') }}</label>
                        <div class="col-sm-3" v-bind:class="{'form-group--error': $v.shipper.registered_account.$error }">
                          <input v-model.trim="shipper.registered_account" @input="$v.shipper.registered_account.$touch()" type="text" name="registered_account" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="address_line1" class="col-sm-2 col-form-label">{{ $t('shipper.address_line1') }}</label>
                        <div class="col-sm-6" v-bind:class="{'form-group--error': $v.shipper.address_line1.$error }">
                          <input v-model.trim="shipper.address_line1" @input="$v.shipper.address_line1.$touch()" type="text" name="address_line1" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="address_line2" class="col-sm-2 col-form-label">{{ $t('shipper.address_line2') }}</label>
                        <div class="col-sm-6">
                          <input v-model.trim="shipper.address_line2" type="text" name="address_line2" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="city" class="col-sm-2 col-form-label">{{ $t('shipper.city') }}</label>
                        <div class="col-sm-3" v-bind:class="{'form-group--error': $v.shipper.city.$error }">
                          <input v-model.trim="shipper.city" @input="$v.shipper.city.$touch()" type="text" name="city" class="form-control" />
                        </div>
                        <label for="postal_code" class="col-sm-2 col-form-label">{{ $t('shipper.postal_code') }}</label>
                        <div class="col-sm-3" v-bind:class="{'form-group--error': $v.shipper.postal_code.$error }">
                          <input v-model.trim="shipper.postal_code" @input="$v.shipper.postal_code.$touch()" type="text" name="postal_code" class="form-control" />
                      </div>
                      </div>
                      <div class="form-group row">
                        <label for="division" class="col-sm-2 col-form-label">{{ $t('shipper.division') }}</label>
                        <div class="col-sm-3" v-bind:class="{'form-group--error': $v.shipper.division.$error }">
                          <input v-model.trim="shipper.division" @input="$v.shipper.division.$touch()" type="text" name="division" class="form-control" />
                        </div>
                        <label for="division_code" class="col-sm-2 col-form-label">{{ $t('shipper.division_code') }}</label>
                        <div class="col-sm-3">
                          <input v-model.trim="shipper.division_code" type="text" name="division_code" class="form-control" />
                        </div>
                      </div>

                      <div class="form-group row">
                        <label for="country_code" class="col-sm-2 col-form-label">{{ $t('shipper.country_code') }}</label>
                        <div class="col-sm-3" v-bind:class="{'form-group--error': $v.shipper.country_code.$error }">
                          <input v-model.trim="shipper.country_code" @input="$v.shipper.country_code.$touch()" type="text" name="country_code" class="form-control" />
                        </div>
                        <label for="country_name" class="col-sm-2 col-form-label">{{ $t('shipper.country_name') }}</label>
                        <div class="col-sm-3" v-bind:class="{'form-group--error': $v.shipper.country_name.$error }">
                          <input v-model.trim="shipper.country_name" @input="$v.shipper.country_name.$touch()" type="text" name="country_name" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="contact_person_name" class="col-sm-2 col-form-label">{{ $t('shipper.contact_person') }}</label>
                        <div class="col-sm-3" v-bind:class="{'form-group--error': $v.shipper.contact_person_name.$error }">
                          <input v-model.trim="shipper.contact_person_name" @input="$v.shipper.contact_person_name.$touch()" type="text" name="contact_person_name" class="form-control" />
                        </div>
                        <label for="contact_phone" class="col-sm-2 col-form-label">{{ $t('shipper.contact_phone') }}</label>
                        <div class="col-sm-3" v-bind:class="{'form-group--error': $v.shipper.contact_phone.$error }">
                          <input v-model.trim="shipper.contact_phone" @input="$v.shipper.contact_phone.$touch()" type="text" name="contact_phone" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="status" class="col-sm-2 col-form-label">{{ $t('shipper.status') }}</label>
                        <div class="col-sm-8">
                          <CSwitch class="mx-1" :checked.sync="shipper.status" color="primary" variant="outline" shape="pill"/>
                        </div>
                      </div>
                  </div><!--col-->
              </div><!--row-->

              <div slot="footer">
                <div class="row">
                    <div class="col-7">
                        <div class="float-left"></div>
                    </div><!--col-->
                    <div class="col-5">
                        <div class="float-right">
                            <b-button type="submit" size="sm" variant="primary" @click.stop.prevent="handleSubmit"><i class="fa fa-dot-circle-o"></i> Submit</b-button>
                        </div>
                    </div><!--col-->
                </div><!--row-->
              </div>
          </div><!--card-body-->
      </div><!--card-->
    </form>
   <loading-panel v-if="showLoadingPanel"></loading-panel>
  </div>
</template>
<script>
import { required, minLength } from 'vuelidate/lib/validators'
import loadingPanel from '@/components/LoadingPanel'

export default {
  name: 'ShipperCreate',
  components: {
    loadingPanel
  },
  mounted () {
    this.axios.get('/courier').then(response => {
      this.couriers = response.data
    }).catch(error => {
      console.log(error)
    })
  },
  data () {
    return {
      couriers: [],
      shipper: {
        shipper_account: '',
        billing_account: '',
        duty_account: '',
        shipper_id: '',
        shipper_name: '',
        registered_account: '',
        address_line1: '',
        address_line2: '',
        city: '',
        division: '',
        division_code: '',
        postal_code: '',
        country_code: '',
        contact_person_name: '',
        contact_phone: '',
        status: true
      },
      showLoadingPanel: false,
      showDismissibleAlert: false,
      alertVariant: '',
      alertMessage: '',
      message: ''
    }
  },
  methods: {
    handleSubmit () {
      this.$v.shipper.$touch()
      if (this.$v.shipper.$error) {
        this.$swal({
          title: 'You have not set your Shipper Account',
          text: 'Please Create Shipper Account First!',
          icon: 'warning',
          animation: false,
          customClass: 'animated tada'
        })
        return
      }
      // create shipper
      this.showLoadingPanel = true
      this.axios.post('/delivery/shipper', this.shipper).then(() => {
        this.showLoadingPanel = false
        this.$router.push('/shipper')
      }).catch(error => {
        this.showLoadingPanel = false
        this.showAlert('danger', error.data.message)
      })
    },
    showAlert (alertVariant, message) {
      this.showDismissibleAlert = true
      this.alertVariant = alertVariant
      this.alertMessage = message
    }
  },
  validations: {
    shipper: {
      shipper_account: {
        required,
        minLength: minLength(6)
      },
      billing_account: {
        required
      },
      duty_account: {
        required
      },
      shipper_id: {
        required
      },
      shipper_name: {
        required
      },
      registered_account: {
        required
      },
      address_line1: {
        required
      },
      city: {
        required
      },
      division: {
        required
      },
      postal_code: {
        required
      },
      country_code: {
        required
      },
      country_name: {
        required
      },
      contact_person_name: {
        required
      },
      contact_phone: {
        required
      }
    }
  }
}
</script>
